import { connect } from "react-redux";

// Modules
import { ManageBusinessDaysBase } from "./ManageBusinessDaysBase";
import Render from "./ManageBusinessDaysRender";

// Components
import withNotifications from "../withNotifications";

class ManageBusinessDays extends ManageBusinessDaysBase {
  render() {
    return Render.call(this, this.props, this.state);
  }
}

const mapStateToProps = state => ({
  user: state.user || {},
  buyers: state.buyers || [],
  users: state.users || [],
});

export default connect(mapStateToProps)(withNotifications(ManageBusinessDays));
